export function initMathJax(msgCount, msgGetter: (i: number) => HTMLDivElement) {
    try {
        for (let i = 0; i < msgCount; i++) {
            processFormulas(msgGetter(i));
        }
    } catch (error) {
        console.info('An error occurs while mathjax lib is being loading');
    }

}

export function processFormulas(el: HTMLDivElement) {
    try {
        const MathJax = window.mj;
        if (MathJax) {
            setTimeout(() => {

                if (el && hasMathJaxFormula(el.innerText) && MathJax.texReset) {
                    MathJax.texReset();
                    MathJax.typesetClear();
                    MathJax.typesetPromise([el]).catch(function (err) {
                        console.error(err);
                    });
                }
            });
        }
    } catch (error) {
        console.info('An error occurs while mathjax formulas are being processed');
    }
}

export function hasMathJaxFormula(text) {
    const pattern = /(?<!\d)\$([^$\n]+)\$(?!\d)/g;
    const matches = [];
    let match;

    while ((match = pattern.exec(text)) !== null) {
        matches.push("Inline formula: " + match[1]);
    }

    return !!matches.length;
}